import BadenBowerLogo from '../images/BB-logo-3.png';
import AirWallexLogo from '../images/airwallex-logo.jpg';

const PaymentCompleted = () => {
  return (
    <div className="flex w-full h-full items-center justify-center">
      <div className="">
        <div className="flex w-full grow justify-center">
          <img src={BadenBowerLogo} alt="badenbower-logo" className="mb-5" />
        </div>
        <div className="sm:border border-gray-200 rounded shadow sm:mt-10 mb-10 p-8 bg-green-200">
          <div className="font-bold text-green-900">
            Your payment has been processed successfully.
          </div>
        </div>
        <div className="flex justify-center items-center flex-col">
          <img src={AirWallexLogo} alt="airwallex-logo" className="mt-10" />
          <div className="font-bold text-sm m-1">
            Payment processed securely by&nbsp;
            <a
              href="https://www.airwallex.com/"
              target="_blank"
              rel="noreferrer"
              className="text-blue-700"
            >
              Airwallex
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCompleted;
